import React, { useState } from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';
import PressModal from './PressModal';

const pressImages = [
  { publication: 'ALLERS', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/0sztal40_Skjermbilde%202025-12-09%20kl.%2023.32.04.png' },
  { publication: 'TARA', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/u944fben_Skjermbilde%202025-12-09%20kl.%2023.32.28.png' },
  { publication: 'WOMAN', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/g722d5sb_Skjermbilde%202025-12-09%20kl.%2023.37.42.png' },
  { publication: 'COSMOPOLITAN', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/3giebba8_Skjermbilde%202025-12-09%20kl.%2023.38.27.png' },
  { publication: 'Press 6', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/89qb0fuv_Skjermbilde%202025-12-09%20kl.%2023.39.39.png' },
  { publication: 'Press 7', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/v0dy8mba_Skjermbilde%202025-12-09%20kl.%2023.44.05.png' },
  { publication: 'Press 8', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/m11spjk3_Skjermbilde%202025-12-09%20kl.%2023.44.42.png' },
  { publication: 'Press 9', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/4g4f600j_Skjermbilde%202025-12-09%20kl.%2023.44.59.png' },
  { publication: 'Press 10', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/kf3hc8jm_Skjermbilde%202025-12-09%20kl.%2023.45.10.png' },
  { publication: 'Press 11', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/s6cfxtul_Skjermbilde%202025-12-09%20kl.%2023.45.24.png' },
  { publication: 'Press 12', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/ifjbk4j8_Skjermbilde%202025-12-09%20kl.%2023.46.31.png' },
  { publication: 'Press 13', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/nn6rgdxq_Skjermbilde%202025-12-09%20kl.%2023.46.55.png' },
  { publication: 'Press 14', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/100tb36y_Skjermbilde%202025-12-09%20kl.%2023.47.09.png' },
  { publication: 'Press 15', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/19o894xu_Skjermbilde%202025-12-09%20kl.%2023.49.08.png' },
  { publication: 'Press 16', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/azrthjjg_Skjermbilde%202025-12-09%20kl.%2023.49.41.png' },
  { publication: 'Press 17', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/onfskurt_Skjermbilde%202025-12-09%20kl.%2023.50.05.png' },
  { publication: 'Press 18', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/zjfnjulz_Skjermbilde%202025-12-09%20kl.%2023.50.17.png' },
  { publication: 'Press 19', image: 'https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/qp84gkny_Skjermbilde%202025-12-09%20kl.%2023.50.28.png' },
];

const PressCarousel = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <div className="w-full max-w-6xl mx-auto px-6" data-testid="press-carousel">
        <Carousel className="w-full">
          <CarouselContent>
            {pressImages.map((press, index) => (
              <CarouselItem key={index} className="md:basis-1/3 lg:basis-1/5">
                <div className="flex items-center justify-center p-2" data-testid={`press-item-${index}`}>
                  <button 
                    onClick={() => setSelectedImage(press)}
                    className="w-40 h-40 rounded-full overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer"
                  >
                    <img 
                      src={press.image} 
                      alt={press.publication} 
                      className="w-full h-full object-cover"
                    />
                  </button>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="-left-4" data-testid="carousel-prev" />
          <CarouselNext className="-right-4" data-testid="carousel-next" />
        </Carousel>
      </div>
      
      {selectedImage && (
        <PressModal 
          image={selectedImage.image}
          publication={selectedImage.publication}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
};

export default PressCarousel;